var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsAppI(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3049_7849)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.09619,
    y: 1,
    width: 28,
    height: 28,
    rx: 14,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.44244,
    y: 1.34625,
    width: 27.3075,
    height: 27.3075,
    rx: 13.6538,
    stroke: "#D0D5DD",
    strokeWidth: 0.692494
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1319 14.9515C23.1319 18.8629 19.9611 22.0338 16.0496 22.0338C14.5577 22.0338 13.1735 21.5725 12.032 20.7847L9.61113 21.3899L10.2455 19.0111C9.43999 17.8615 8.96729 16.4617 8.96729 14.9515C8.96729 11.04 12.1381 7.86914 16.0496 7.86914C19.9611 7.86914 23.1319 11.04 23.1319 14.9515Z",
    fill: "url(#paint0_linear_3049_7849)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0493 23.2149C20.6127 23.2149 24.312 19.5155 24.312 14.9522C24.312 10.3888 20.6127 6.68945 16.0493 6.68945C11.486 6.68945 7.78662 10.3888 7.78662 14.9522C7.78662 16.4341 8.17674 17.8249 8.85987 19.0274L7.78662 23.2149L12.1038 22.2138C13.2762 22.8522 14.6204 23.2149 16.0493 23.2149ZM16.0493 21.9437C19.9106 21.9437 23.0409 18.8135 23.0409 14.9522C23.0409 11.0909 19.9106 7.96064 16.0493 7.96064C12.188 7.96064 9.05781 11.0909 9.05781 14.9522C9.05781 16.443 9.52445 17.8249 10.3196 18.9597L9.6934 21.3081L12.0832 20.7107C13.2101 21.4883 14.5765 21.9437 16.0493 21.9437Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9839 11.1163C13.7874 10.7217 13.486 10.7566 13.1816 10.7566C12.6375 10.7566 11.7891 11.4084 11.7891 12.6213C11.7891 13.6154 12.2271 14.7036 13.7032 16.3314C15.1277 17.9023 16.9994 18.715 18.5532 18.6873C20.1071 18.6597 20.4268 17.3225 20.4268 16.8709C20.4268 16.6708 20.3026 16.5709 20.217 16.5438C19.6875 16.2897 18.7109 15.8162 18.4887 15.7272C18.2665 15.6382 18.1504 15.7586 18.0783 15.824C17.8768 16.0161 17.4774 16.582 17.3406 16.7093C17.2038 16.8366 16.9999 16.7722 16.915 16.7241C16.6028 16.5988 15.7562 16.2222 15.0813 15.568C14.2467 14.7589 14.1977 14.4806 14.0404 14.2328C13.9147 14.0346 14.007 13.9129 14.053 13.8598C14.2328 13.6523 14.4811 13.332 14.5925 13.1728C14.7038 13.0136 14.6155 12.7719 14.5624 12.6213C14.3343 11.9739 14.141 11.432 13.9839 11.1163Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3049_7849",
    x: 0.711204,
    y: 0.307506,
    width: 30.77,
    height: 30.77,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.692494
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.692494
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3049_7849"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3049_7849",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3049_7849",
    x1: 16.0496,
    y1: 7.86914,
    x2: 16.0496,
    y2: 22.0338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BD066"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27B43E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsAppI);
export default __webpack_public_path__ + "static/media/whatsApp-i.c66a86dd0f4f634363d8ae9e79b3d959.svg";
export { ForwardRef as ReactComponent };